module.exports = __webpack_public_path__ + "img/qj_nodata.21ef0099.png";